import React from 'react'
import { SignUp } from '@clerk/clerk-react'

export default function SignUpPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img src="/logo.svg" alt="Neoserve" className="h-10 w-10" />
            <span className="text-2xl font-bold text-gray-900">Neoserve</span>
          </div>
          <p className="text-gray-500">Create your account to get started</p>
        </div>
        <SignUp
          routing="hash"
          afterSignUpUrl="/dashboard"
          signInUrl="/sign-in"
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'shadow-xl rounded-2xl border border-gray-200',
            },
          }}
        />
      </div>
    </div>
  )
}
